"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSearchResults = exports.UserSearchResultsDefaultArgs = void 0;
var get_component_1 = require("../../shared/helpers/get-component");
var il_dropdown_common_1 = require("../il-dropdown/il-dropdown.common");
var user_search_results_table_1 = require("./user-search-results-table");
var UserSearchResultsDefaultArgs = {
    headerText: 'Search Results',
    countText: 'Users',
    emptyText: 'No Users Found',
    boldPhrase: '',
    users: __spreadArray(__spreadArray([], il_dropdown_common_1.StudentFilterImplementationArgs, true), [
        __assign(__assign({}, il_dropdown_common_1.StudentFilterImplementationArgs.at(-1)), { shopifyId: 'Some-Shopify-Id', firstName: 'Joey', email: 'joey@email.com' }),
    ], false),
    onSelectUser: console.log,
};
exports.UserSearchResultsDefaultArgs = UserSearchResultsDefaultArgs;
var UserSearchResults = (0, get_component_1.getComponent)(user_search_results_table_1.UserSearchResultsTable, UserSearchResultsDefaultArgs);
exports.UserSearchResults = UserSearchResults;
